import type { Sesion } from '../auth'

/**
 * A dónde debe ir el usuario tras login / al pedir `/` (FR-005 · FR-006a).
 * `null` = quedarse en ruta actual (admin en portada).
 */
export function destinoTrasLogin(sesion: Sesion): string | null {
    if (sesion.role === 'admin') return '/'
    const ids = sesion.accountIds ?? []
    if (ids.length === 0) return '/sin-negocio'
    if (ids.length === 1) return `/business/${ids[0]}`
    return `/business/${ids[0]}` // selector en Layout; aterriza en el primero
}

export function clientePuedeVerConsola(sesion: Sesion): boolean {
    return sesion.role === 'admin'
}
